import script from "./AddImageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddImageModal.vue?vue&type=script&setup=true&lang=js"

import "./AddImageModal.vue?vue&type=style&index=0&id=89e3469c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89e3469c"]])

export default __exports__